module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    ref: "baseball",
    attrs: {
      "id": "permission-profile-dialog",
      "top": "3vh",
      "width": "60rem",
      "center": true,
      "show-close": true,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "visible": _vm.showProfileDialog,
      "destroy-on-close": true,
      "append-to-body": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showProfileDialog = $event
      }
    }
  }, [_c('div', {
    attrs: {
      "id": "profile-card"
    }
  }, [_c('div', {
    attrs: {
      "id": "header-card"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-top": "0",
      "text-align": "center"
    }
  }, [_c('el-image', {
    staticStyle: {
      "border-radius": "15px"
    },
    attrs: {
      "id": "image",
      "src": _vm.imageSrc,
      "fit": 'cover'
    }
  }, [_c('div', {
    staticClass: "image-slot",
    attrs: {
      "slot": "error"
    },
    slot: "error"
  }, [_c('i', {
    staticClass: "el-icon-picture-outline"
  })])]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.initialProfile.identifier))])], 1), _vm._v(" "), _c('div', {
    staticClass: "centered-tabs"
  }, [_c('el-tabs', {
    attrs: {
      "id": "visible-tabs",
      "stretch": true
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Demographics",
      "name": "demographics"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "OptIns",
      "name": "optin"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Interactions",
      "name": "interactions"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Activity Logs",
      "name": "logs"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "hidden-tabs"
    }
  }, [_c('el-tabs', {
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Demographics",
      "name": "demographics"
    }
  }, [(_vm.demographics.length === 0 && !_vm.$apollo.queries.profile.loading) ? _c('p', [_vm._v("\n            Not enough demographics has been gathered yet to display any results\n          ")]) : _vm._e(), _vm._v(" "), _c('demographics-tab', {
    attrs: {
      "loading": _vm.$apollo.queries.profile.loading,
      "demographics": _vm.demographics,
      "isProfileEditModeOn": _vm.isProfileEditModeOn,
      "isProfileLocked": _vm.isProfileLocked,
      "handleShowAlert": _vm.handleShowAlert
    },
    on: {
      "edit-nugget": _vm.handleEditNugget,
      "remove-nugget": _vm.handleRemoveNugget
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Interactions",
      "name": "interactions"
    }
  }, [(_vm.processedInteractions.length === 0 && !_vm.$apollo.queries.profile.loading) ? _c('p', [_vm._v("\n            Not enough Interactions have been gathered yet to display any results\n          ")]) : _vm._e(), _vm._v(" "), _c('interactions-tab', {
    attrs: {
      "loading": _vm.$apollo.queries.profile.loading,
      "interactions": _vm.processedInteractions
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Opt-in",
      "name": "optin"
    }
  }, [_c('optins-tab', {
    attrs: {
      "loading": _vm.$apollo.queries.profile.loading,
      "optins": _vm.optins
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Logs",
      "name": "logs"
    }
  }, [_c('activity-logs-tab', {
    attrs: {
      "loading": _vm.loading,
      "initialProfile": _vm.initialProfile,
      "activityLogs": _vm.activityLogs,
      "currentPage": _vm.currentPage,
      "hasNext": _vm.hasNext,
      "hasPrevious": _vm.hasPrevious
    },
    on: {
      "loadMore": _vm.handleLoadMore,
      "loadPrevious": _vm.handleLoadPrevious
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.verificationAlert) ? _c('div', {
    class: {
      'verification-alert': true, 'shake': _vm.shakeAnimation, 'alert-danger': true,
      'text-center': true, 'animated': true
    },
    on: {
      "animationend": _vm.handleAnimationEnd
    }
  }, [_c('span', {
    staticClass: "close",
    on: {
      "click": _vm.handleClearAlert
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('p', [_vm._v("\n        " + _vm._s(_vm.verificationAlert) + "\n        "), _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openVerifyOTPDialog($event)
      }
    }
  }, [_vm._v("Verify Profile")])])]) : _vm._e()]), _vm._v(" "), (_vm.showEnhanceProfileDialog) ? _c('el-dialog', {
    attrs: {
      "id": "enhance-profile-dialog",
      "top": "5vh",
      "width": "100rem",
      "title": "Update Profile",
      "show-close": true,
      "close-on-click-modal": true,
      "close-on-press-escape": true,
      "visible": _vm.showEnhanceProfileDialog,
      "destroy-on-close": true,
      "append-to-body": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showEnhanceProfileDialog = $event
      }
    }
  }, [_c('enhance-profile-form', {
    attrs: {
      "demographics": _vm.demographics,
      "optins": _vm.optins,
      "initialMobileNumber": _vm.initialMobileNumber(),
      "visible": _vm.showEnhanceProfileDialog,
      "getNuggetCategory": _vm.getNuggetCategory
    },
    on: {
      "close": function($event) {
        _vm.showEnhanceProfileDialog = false
      },
      "updateProfile": _vm.handleUpdateProfile,
      "updateOptins": _vm.handleUpdateOptins
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showVerifyOTPDialog) ? _c('verify-dialog', {
    attrs: {
      "visible": _vm.showVerifyOTPDialog,
      "initialProfile": _vm.initialProfile,
      "initialMobileNumber": _vm.initialMobileNumber()
    },
    on: {
      "close": _vm.handleCloseVerifyOTPDialog,
      "requestOTP": _vm.handleRequestOTP,
      "verifyOTP": _vm.handleVerifyOTP
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "content": "Add profile demographics",
      "placement": "top"
    }
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDemographicsTabActive),
      expression: "isDemographicsTabActive"
    }],
    staticClass: "ibox-tool-btn",
    attrs: {
      "icon": "el-icon-edit",
      "type": "primary",
      "size": "small",
      "plain": "",
      "disabled": _vm.$apollo.queries.profile.loading
    },
    on: {
      "click": function($event) {
        !_vm.isProfileEditModeOn ? _vm.handleShowAlert() : _vm.openEnhanceProfileForm()
      }
    }
  }, [_vm._v("Enhance Profile")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "content": _vm.isProfileLocked ? 'Make profile accessible externally' : 'Make profile inaccessible externally',
      "placement": "top"
    }
  }, [_c('el-button', {
    staticClass: "ibox-tool-btn",
    attrs: {
      "icon": _vm.isProfileLocked ? 'el-icon-unlock' : 'el-icon-lock',
      "type": "default",
      "size": "small",
      "plain": "",
      "disabled": _vm.$apollo.queries.profile.loading,
      "loading": _vm.loading
    },
    on: {
      "click": _vm.handleLockProfileState
    }
  }, [_vm._v("\n          " + _vm._s(_vm.isProfileLocked ? 'Unlock Profile' : 'Lock Profile') + "\n        ")])], 1), _vm._v(" "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "content": "Delete profile",
      "placement": "top"
    }
  }, [_c('el-button', {
    staticClass: "ibox-tool-btn",
    attrs: {
      "icon": "el-icon-delete",
      "type": "danger",
      "size": "small",
      "plain": "",
      "disabled": _vm.$apollo.queries.profile.loading
    },
    on: {
      "click": function($event) {
        !_vm.isProfileEditModeOn ? _vm.handleShowAlert() : _vm.handleDeleteProfile()
      }
    }
  }, [_vm._v("Delete Profile")])], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76cea568","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/permission/profile/DialogCard.vue
// module id = 3346
// module chunks = 3